import type { ListBuilderList } from '../../../types';
import { createStandardTaskColumns } from '../columns';

/**
 * This Week Tasks list configuration
 * Shows pending tasks due this week
 */
export const thisWeekTasksList: ListBuilderList = {
	id: 'this-week-tasks',
	cacheTTL: 300000,
	name: 'This Week',
	type: 'default',
	active: true,
	sortOrder: 4,
	activeFilters: [
		'taskKeywords',
		'taskStatus',
		'taskPriority',
		'taskAssignedUser',
		'taskClient',
		'taskLeadOrCustomer',
		'taskDueDateRange',
		'taskExternalCalendars',
	],
	columns: createStandardTaskColumns(),
	defaultSortId: 'column-due-date-column-asc',
	filterRules: {
		taskAssignedUser: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'tasks:view:any', negated: true }],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [{ type: 'rule', action: 'tasks:view:any', negated: true }],
			},
		},
		taskDueDateRange: {
			defaultValue: [
				{
					id: 'this-week',
					label: 'This Week',
					data: {
						startDate: '{{DATE:start_of_week}}',
						endDate: '{{DATE:end_of_week}}',
					},
				},
			],
		},
		taskStatus: {
			defaultValue: [{ id: 'pending', label: 'Pending' }],
		},
	},
};
